import React from "react"
import types from "prop-types"
import clsx from "clsx"

const LargeWrap = ({ className = "", children = null }) => (
  <section
    className={clsx(
      "large-wrap",
      className,
    )}
  >
    {children}
  </section>
)

LargeWrap.propTypes = {
  children: types.node,
  className: types.string,
}

export default LargeWrap
